import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  Checkbox,
  FormGroup,
  FormControl,
  FormControlLabel,
  InputLabel,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { MdModeEdit, MdOutlineClose } from "react-icons/md";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useNotification } from "../../../../hooks/useNotification";
import useStyles from "../../../../themes/style.js";

const KYCDetails = ({ userDetails, onUpdate }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);
    
  

  const handleNotificationCall = useNotification();

  const validationSchema = Yup.object().shape({
    aadhaarNumber: Yup.string().required("Aadhar Number is required"),
    panNumber: Yup.string().required("PAN Number is required"),
    pfNumber: Yup.string().nullable(),
    uanNumber: Yup.string().nullable(),
    esiNumber: Yup.string().nullable(),
    bankName: Yup.string().nullable(),
    bankAccountNumber: Yup.string().nullable(),
    bankIfscCode: Yup.string().nullable(),
    isPfPercentage: Yup.boolean()
      .required("This field is required")
      .oneOf([true, false], "Invalid value for PF Select"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues:{
      isPfPercentage: false,
    }
  });

  useEffect(() => {
    const salaryDetail = userDetails?.salary_detail;

    if (salaryDetail) {
      setValue("aadhaarNumber", salaryDetail.aadhaarNumber);
      setValue("esiNumber", salaryDetail.esiNumber);
      setValue("uanNumber", salaryDetail.uanNumber);
      setValue("panNumber", salaryDetail.panNumber);

      setValue("pfNumber", salaryDetail.pfNumber);
      setValue("bankName", salaryDetail.bankName);
      setValue("bankAccountNumber", salaryDetail.bankAccountNumber);
      setValue("bankIfscCode", salaryDetail.bankIfscCode);
    }
  }, []);

  const handleEditEmployee = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/editUserKycDetails`,
        {
          ...values,
          userId: userDetails.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        setEnableEdit(false);
        onUpdate();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  return (
    <div>
      <Box>
        <div className="emp-profile-details-table-card">
          <h3 className="gradienttext">KYC Details</h3>
          {!enableEdit ? (
            <button
              className="emp-profile-edit-button"
              onClick={() => setEnableEdit(!enableEdit)}
            >
              <MdModeEdit color="#056dfa" className="svg-icon" />
              <span className="lable">Edit</span>
            </button>
          ) : (
            <button
              className="emp-profile-edit-button emp-profile-cancel-button"
              onClick={() => setEnableEdit(false)}
            >
              <MdOutlineClose color="#fa0505" className="svg-icon" />
              <span className="lable">Cancel</span>
            </button>
          )}
          {!enableEdit ? (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <table className="emp-profile-details-table">
                  <tbody>
                    <tr>
                      <td>Aadhaar Number</td>
                      <td>
                        {userDetails.salary_detail?.aadhaarNumber || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PAN Number</td>
                      <td>
                        {userDetails.salary_detail?.panNumber || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>UAN Number</td>
                      <td>
                        {userDetails.salary_detail?.uanNumber ? (
                          userDetails.salary_detail?.uanNumber
                        ) : (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>ESI Number</td>
                      <td>
                        {userDetails.salary_detail?.esiNumber || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <table className="emp-profile-details-table">
                  <tbody>
                    <tr>
                      <td>PF Number</td>
                      <td>
                        {userDetails.salary_detail?.pfNumber || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Bank Name</td>
                      <td>
                        {userDetails.salary_detail?.bankName ? (
                          userDetails.salary_detail?.bankName
                        ) : (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Bank Account Number</td>
                      <td>
                        {userDetails.salary_detail?.bankAccountNumber ? (
                          userDetails.salary_detail?.bankAccountNumber
                        ) : (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Bank IFSC Code</td>
                      <td>
                        {userDetails.salary_detail?.bankIfscCode ? (
                          userDetails.salary_detail?.bankIfscCode
                        ) : (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
          ) : (
            <form
              onSubmit={handleSubmit(handleEditEmployee)}
              style={{ padding: "10px" }}
            >
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="aadhaarNumber">
                    Aadhaar Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Aadhaar Number"
                      name="aadhaarNumber"
                      {...register("aadhaarNumber")}
                      error={errors.aadhaarNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.aadhaarNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="panNumber">
                    PAN Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter PAN Number"
                      name="panNumber"
                      {...register("panNumber")}
                      error={errors.panNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.panNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="uanNumber">
                    UAN Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter UAN Number"
                      name="uanNumber"
                      {...register("uanNumber")}
                      error={errors.uanNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.uanNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="esiNumber">
                    ESI Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter ESI Number"
                      name="esiNumber"
                      {...register("esiNumber")}
                      error={errors.esiNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.esiNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="pfNumber">
                    PF Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter PF Number"
                      name="pfNumber"
                      {...register("pfNumber")}
                      error={errors.pfNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.pfNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="bankName">
                    Bank Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Bank Name"
                      name="bankName"
                      {...register("bankName")}
                      error={errors.bankName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.bankName?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="bankAccountNumber">
                    Bank Account Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Bank Account Number"
                      name="bankAccountNumber"
                      {...register("bankAccountNumber")}
                      error={errors.bankAccountNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.bankAccountNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="bankIfscCode">
                    Bank IFSC Code
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Bank IfscCode"
                      name="bankIfscCode"
                      {...register("bankIfscCode")}
                      error={errors.bankIfscCode ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.bankIfscCode?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="isPfPercentage">
                    PF Excess Contribution
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="isPfPercentage"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value === true}
                                onChange={() => onChange(true)}
                              />
                            }
                            label="Employee & Employer contribution - 12% with in wage ceiling (Max Rs.1800)"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value === false}
                                onChange={() => onChange(false)}
                              />
                            }
                            label="Employee contribution - 12% over and above wage ceiling (In excess to Rs.1800)"
                          />
                        </FormGroup>
                      )}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.isPfPercentage?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    style={{ flex: 1, margin: "0px 6px" }}
                    onClick={() => setEnableEdit(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ flex: 1, margin: "0px 6px" }}
                    type="submit"
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </div>
      </Box>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default KYCDetails;
